// extracted by mini-css-extract-plugin
export var active = "menu-module--active--29e91";
export var link = "menu-module--link--52d44";
export var menu = "menu-module--menu--02db7";
export var menuItem = "menu-module--menu-item--53d0f";
export var menuItemPrimary = "menu-module--menu-item-primary--504ca";
export var menuWrapper = "menu-module--menu-wrapper--4aa34";
export var open = "menu-module--open--fd69c";